import type { FC } from 'react';
import { StyledFailureAlert, StyledAlertContent, StyledRetryAction } from './FailureAlertBanner.styles';

interface FailureAlertBannerProps {
    onRetryAll: () => void;
    isRetryDisabled: boolean;
}

export const FailureAlertBanner: FC<FailureAlertBannerProps> = ({ onRetryAll, isRetryDisabled }) => (
    <StyledFailureAlert type="error" data-testid="alt-deal-failure-alert">
        <StyledAlertContent>
            Certain Deal Structure options aren&apos;t available at the moment. Please retry or proceed with the options currently
            displayed.{' '}
            <StyledRetryAction data-testid="retry-rates-link" onClick={onRetryAll} disabled={isRetryDisabled}>
                Retry Rates
            </StyledRetryAction>
        </StyledAlertContent>
    </StyledFailureAlert>
);
